// const ORIGIN = window.location.origin; // http://localhost:3000, https://<dist>.cloudfront.net, or https://find.clemsonhub.org
// const host = new URL(ORIGIN).hostname;

// const isLocal = host === "localhost" || host === "127.0.0.1";
// const isCloudFront = host.endsWith("cloudfront.net");

// // When app is on cloudfront.net or localhost -> use default Hosted UI domain
// // Otherwise -> use your custom Hosted UI domain
// const COGNITO_DOMAIN = (isCloudFront || isLocal)
//   ? "us-east-2akbvbr70i.auth.us-east-2.amazoncognito.com"// e.g. mypoolprefix.auth.us-east-2.amazoncognito.com
//   : "findauth.clemsonhub.org";
// const REDIRECT_SIGNIN  = `${ORIGIN}/`;            // note trailing slash
// const REDIRECT_SIGNOUT = `${ORIGIN}/signed-out`;  // must exist in your router

// const awsconfig = {
//   Auth: {
//     Cognito: {
//       region: "us-east-2",
//       userPoolId: "us-east-2_AKbVBr70I",        // your pool id
//       userPoolClientId: "7q4bg5dkh00cluf5q3mqalh8ht", // your PUBLIC client (no secret)
//       loginWith: {
//         oauth: {
//           // hostname only (⚠️ no https://, no trailing slash)
//           domain: COGNITO_DOMAIN,

//           // Must match what you ticked in Cognito Hosted UI
//           scopes: ["email","openid","phone","profile"],

//           // Arrays of URLs, must match console exactly (trailing slash!)
//           redirectSignIn:  [REDIRECT_SIGNIN],
//           redirectSignOut: [REDIRECT_SIGNOUT],

//           responseType: "code", // Authorization Code + PKCE
//         },
//       },
//     },
//   },
// };
// export default awsconfig;

// XXX this should come from build vars
const awsconfig = {
  Auth: {
    Cognito: {
      region: process.env.REACT_APP_AWS_REGION,
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
      // No hosted UI domain or redirect URLs needed
      loginWith: {
        username: true,
        email: true,
      },
    },
  },
};

export default awsconfig;
